import React from 'react';
import styles from './Dashboard.module.scss';
import { ReactComponent as FilesIcon } from 'assets/icons/files.svg';
import { Link } from 'react-router-dom';

interface ArticleProps {
  title: string;
  date?: string;
  time?: number;
  link: string;
}

const ArticleCard = ({ title, date, time, link }: ArticleProps): React.ReactElement => {
  return (
    <div className={styles.articleCard}>
      <div className={styles.iconContainer}>
        <FilesIcon />
      </div>
      <div className={styles.infoContainer}>
        <Link to={link} className={styles.title} target="_blank">
          {title}
        </Link>
        <p className={styles.sub}>
          {date} {`${time ? '| ' + time + ' min reading' : ''}`}
        </p>
      </div>
    </div>
  );
};

export default ArticleCard;
